// ** I18n Imports
import i18n from 'i18next'
import {initReactI18next} from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

/*
  Module for declaring the i18n configuration options.
  Params:
    - OLYMPUS_LOCALES_DIR : olympus locales (webpack conf)
    - MY_LOCALES_DIR : thirdapp locales (webpack conf)

    ===================================================
    in your thirdApp config webpack:
     webpack: {
        ...
        plugins: [
            new webpack.DefinePlugin({
                MY_LOCALES_DIR: '../../../../assets/data/locales',
                OLYMPUS_LOCALE_DIR : './data/locales',
            })
        ]
        ...
    }
    ===================================================
*/

class Language {

    constructor(lang_code, data) {
        this.lang_code = lang_code
        this.data = data
    }

    extendWithData(olympusData) {
        const my_data = this.data
        this.data = {
            ...olympusData,
            ...my_data
        }
    }
}

function loadMessages() {
    const thirdAppTranslations = [], olympusWebTranslations = []

    const third_app_locales = require.context(MY_LOCALES_DIR, true, /[A-Za-z0-9-_,\s]+\.json$/i)
    third_app_locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched[1].length === 2) {
            if (thirdAppTranslations.find((item) => item.lang_code === matched[1]) !== undefined)
                console.error(`Duplicate THIRD_APP_LOCALE file name: ${key}`)
            else thirdAppTranslations.push(new Language(matched[1], third_app_locales(key)))
        } else {
            console.error(`Invalid THIRD_APP_LOCALE file name: ${key}`)
        }
    });

    const olympus_locales = require.context(OLYMPUS_LOCALES_DIR, true, /[A-Za-z0-9-_,\s]+\.json$/i)
    olympus_locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched[1].length === 2) {
            if (olympusWebTranslations.find((item) => item.lang_code === matched[1]) !== undefined)
                console.error(`Duplicate OLYMPUS_APP_LOCALE name: ${key}`)
            else olympusWebTranslations.push(new Language(matched[1], olympus_locales(key)))
        } else {
            console.error(`Invalid key OLYMPUS_APP_LOCALE name: ${key}`)
        }
    });
    return [olympusWebTranslations, thirdAppTranslations]
}

function mergeMessages(olympusWebTranslations, thirdAppTranslations) {
    // ** Initialize as OlympusWebTranslations
    const translationLanguages = [...olympusWebTranslations]

    // ** Find thirdApp Translations and merge them if they exists, else create
    thirdAppTranslations.forEach((translationLanguage) => {
        const foundLanguage = translationLanguages.find((item) => item.lang_code === translationLanguage.lang_code)
        if (foundLanguage !== undefined) {
            // ** Load also thirdApp Translation data.
            foundLanguage.extendWithData(translationLanguage.data)
        } else translationLanguages.push(new Language(translationLanguage))
    })
    return translationLanguages
}

function createFormattedResources(translationLanguages) {
    //** Formatted as i18n-next "resources" option
    // https://react.i18next.com/legacy-v9/step-by-step-guide
    const resourceOptions = {}

    translationLanguages.forEach((language) => {
        resourceOptions[language.lang_code] = {
            translation: language.data
        }
    })
    return resourceOptions
}

function getLanguageFromSession(default_app_lang) {
    if(localStorage.i18nextLng)
        return localStorage.i18nextLng
    else return default_app_lang
}

function initializei18n(default_app_lang) {

    const AllTranslations = loadMessages()
    const mergedAppTranslations = mergeMessages(AllTranslations[0], AllTranslations[1])

    i18n
        // Enable automatic language detection
        .use(LanguageDetector)
        // Enables the hook initialization module
        .use(initReactI18next)
        .init({
            lng: getLanguageFromSession(default_app_lang),
            resources: createFormattedResources(mergedAppTranslations),
            fallbackLng: 'en',
            debug: false,
            keySeparator: false,
            react: {
                useSuspense: false
            },
            interpolation: {
                escapeValue: false,
                formatSeparator: ','
            }
        })

    return i18n
}

export {
    initializei18n
}
